import React, { useEffect, useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { Outlet, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getClientDetails } from "../../actions/client/clientActions";
import "./Products.scss";
import HeaderProducts from "./HeaderProducts";

const ProductsInnerLayout = ({ currentTab, changeTab }) => {
  const { productId } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (productId) {
      dispatch(getClientDetails(productId));
    }
  }, [productId]);

  console.log("====currentTab", currentTab);
  return (
    <Box w="100%" bg="var(--body-bg)">
      <Box>
        <HeaderProducts currentTab={currentTab} changeTab={changeTab} />
      </Box>
    </Box>
  );
};

export default ProductsInnerLayout;
